/**
 * noVNC tunnel to a browserfarm pod, through the backoffice.
 *
 * The ticket is NOT in the URL: a query string lands in every ingress and
 * proxy access log, and the ticket opens a logged-in LinkedIn session for ten
 * minutes. A browser WebSocket cannot set an Authorization header either, so
 * the ticket rides the `Sec-WebSocket-Protocol` header, offered next to
 * "binary" (the backoffice accepts "binary").
 */

export interface VncTicketProtocol {
  token: string;
  subprotocol: string;
}

/** WebSocket URL of the tunnel: same host as the API, ws(s) scheme. */
export function vncWebSocketUrl(apiUrl: string, origin: string): string {
  const base = new URL(apiUrl, origin);
  base.protocol = base.protocol === "https:" ? "wss:" : "ws:";
  const path = base.pathname.replace(/\/+$/, "");
  return `${base.origin}${path}/browserfarm/vnc`;
}

/** Subprotocols the noVNC client offers. */
export function vncProtocols(ticket: VncTicketProtocol): string[] {
  return ["binary", ticket.subprotocol];
}
